export default __webpack_public_path__ + "static/media/referEarn.cf5aaca7.png";